import React, { forwardRef } from "react";

import { StyledRow } from "./Styles";
import { Breakpoint } from "../BreakPoints";
import { Align, Space } from "../LayoutTokens";

export interface IRowProps extends React.ComponentPropsWithoutRef<"div"> {
  space?: Space;
  align?: Align;
  collapseBelow?: Breakpoint;
}

export const Row = forwardRef<HTMLDivElement, IRowProps>(
  (
    { space = "md", align = "center", collapseBelow, children, ...rest },
    ref
  ) => (
    <StyledRow
      ref={ref}
      $space={space}
      $align={align}
      $collapse={collapseBelow}
      {...rest}
    >
      {children}
    </StyledRow>
  )
);

Row.displayName = "Row";
